<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.update_ads") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <form @submit.prevent="validateFormInputs">
          <div class="row">
            <p class="text-center">{{ $t("PLACEHOLDERS.images") }}</p>
            <UploadMedia
              :multiple="true"
              :for_id="'ad_images'"
              :content="$t('PLACEHOLDERS.images')"
              ref="ad_images"
              accept="image/*"
            />
            <base-image-upload-input
              col="12"
              identifier="video"
              :placeholder="$t('PLACEHOLDERS.video')"
              :acceptVideo="true"
              @selectImage="selectVideo"
              required
              :preSelectedImage="data.video.path"
            />
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.license_number')"
              v-model.trim="data.license_number"
            />
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.ad_number')"
              v-model.trim="data.adNum"
              disabled
            />
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.ad_name')"
              v-model.trim="data.name"
            />
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.created_at')"
              v-model.trim="data.created_at"
              disabled
            />
            <ValidationProvider
              :name="$t('PLACEHOLDERS.ad_type')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-select-input
                col="12"
                :placeholder="$t('PLACEHOLDERS.ad_type')"
                v-model="data.ad_type"
                :errors="errors[0]"
                :optionsList="adTypes"
                required
              />
            </ValidationProvider>
            <ValidationProvider
              :name="$t('PLACEHOLDERS.rent_type')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
              v-if="data.ad_type?.value === 'rent'"
            >
              <base-select-input
                col="12"
                :placeholder="$t('PLACEHOLDERS.rent_type')"
                v-model="data.rent_type"
                :optionsList="rentTypes"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.ban_type')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
              v-if="data.rent_type?.value !== 'daily'"
            >
              <base-select-input
                col="12"
                :errors="errors[0]"
                :placeholder="$t('PLACEHOLDERS.ban_type')"
                v-model="data.ban_type"
                :optionsList="banTypes"
                required
              />
            </ValidationProvider>
            <ValidationProvider
              :name="$t('PLACEHOLDERS.estate_purpose')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-select-input
                col="12"
                :errors="errors[0]"
                :placeholder="$t('PLACEHOLDERS.estate_purpose')"
                v-model="data.estate_purpose"
                :optionsList="estatePurposeTypes"
                required
              />
            </ValidationProvider>
            <ValidationProvider
              :name="$t('PLACEHOLDERS.estate_type')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-select-input
                col="12"
                :errors="errors[0]"
                :placeholder="$t('PLACEHOLDERS.estate_type')"
                v-model="data.estate_type"
                :optionsList="estateTypes"
                required
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.price')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="number"
                :placeholder="$t('PLACEHOLDERS.price')"
                v-model="data.price"
                required
                :errors="errors[0]"
              />
            </ValidationProvider>
            <ValidationProvider
              :name="$t('PLACEHOLDERS.state')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-select-input
                col="12"
                :errors="errors[0]"
                v-model="data.state"
                :optionsList="states"
                required
                :placeholder="$t('PLACEHOLDERS.state')"
              />
            </ValidationProvider>
            <ValidationProvider
              :name="$t('PLACEHOLDERS.city')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-select-input
                col="12"
                :errors="errors[0]"
                v-model="data.city"
                required
                :optionsList="cities"
                :placeholder="$t('PLACEHOLDERS.city')"
              />
            </ValidationProvider>
            <ValidationProvider
              :name="$t('PLACEHOLDERS.district')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-select-input
                col="12"
                :errors="errors[0]"
                v-model="data.district"
                :optionsList="districts"
                required
                :placeholder="$t('PLACEHOLDERS.district')"
              />
            </ValidationProvider>

            <p class="mb-5 px-3" style="color: #072e68; font-size: 16px">
              {{ $t("PLACEHOLDERS.location_on_map")
              }}<span class="text-danger"> * </span>
            </p>
            <ChangableMapComponent
              :lat="parseFloat(data.lat)"
              :lng="parseFloat(data.lng)"
              @update:lat="data.lat = $event"
              @update:lng="data.lng = $event"
              @update:placeName="data.address = $event"
            />

            <ValidationProvider
              :name="$t('PLACEHOLDERS.estate_front')"
              rules="required"
              v-slot="{ errors }"
              v-if="data.rent_type?.value !== 'daily'"
              class="col-lg-6"
            >
              <base-select-input
                col="12"
                :errors="errors[0]"
                required
                :placeholder="$t('PLACEHOLDERS.estate_front')"
                :optionsList="facadeTypes"
                v-model="data.estate_front"
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.street_width')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
              v-if="data.rent_type?.value !== 'daily'"
            >
              <base-input
                col="12"
                :errors="errors[0]"
                required
                type="number"
                :placeholder="$t('PLACEHOLDERS.street_width')"
                v-model="data.street_width"
              />
            </ValidationProvider>
            <ValidationProvider
              :name="$t('PLACEHOLDERS.area')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                :errors="errors[0]"
                required
                type="number"
                :placeholder="$t('PLACEHOLDERS.area')"
                v-model="data.area"
              />
            </ValidationProvider>
            <ValidationProvider
              :name="$t('PLACEHOLDERS.description')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                :errors="errors[0]"
                required
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.description')"
                v-model.trim="data.description"
              />
            </ValidationProvider>

            <base-select-input
              col="6"
              v-model="data.additional_fields"
              :optionsList="additional_fields"
              :placeholder="$t('PLACEHOLDERS.additional_fields')"
              multiple
            />

            <template>
              <div class="custom-form-wrapper">
                <div
                  v-for="field in data.additional_fields"
                  :key="field.id"
                  class="custom-form-field"
                >
                  <div v-if="field.type === 'text'">
                    <base-input
                      v-model="field.values"
                      type="text"
                      :placeholder="field.name"
                      :icon="field.icon"
                      :required="Boolean(field.is_required)"
                    />
                  </div>

                  <div v-else-if="field.type === 'number'">
                    <base-input
                      v-model.number="field.values"
                      type="number"
                      :placeholder="field.name"
                      :required="Boolean(field.is_required)"
                      :icon="field.icon"
                    />
                  </div>

                  <div v-else-if="field.type === 'textarea'">
                    <base-input
                      v-model="field.values"
                      type="textarea"
                      :placeholder="field.name"
                      :icon="field.icon"
                      :required="Boolean(field.is_required)"
                    />
                  </div>

                  <div v-else-if="field.type === 'checkbox'" class="my-3">
                    <label class="field-label d-block mb-2">
                      <img v-if="field.icon" :src="field.icon" class="img" />
                      {{ field.name }}
                      <span
                        class="text-danger"
                        v-if="Boolean(field.is_required)"
                        >*</span
                      >
                    </label>
                    <label
                      v-for="option in field?.options"
                      :key="option.id"
                      class="custom-checkbox-wrapper"
                    >
                      <input
                        type="checkbox"
                        class="custom-checkbox-input"
                        :value="option.id"
                        v-model="field.values"
                      />

                      <span
                        class="custom-checkbox-box"
                        :class="{
                          'bg-green-500 border-green-500': field.values.some(
                            (i) => i.id === option.id
                          ),
                          'bg-white border-gray-300': !field.values.some(
                            (i) => i.id === option.id
                          ),
                        }"
                      ></span>
                      <span class="custom-checkbox-label">
                        {{ option.name }}
                      </span>
                    </label>
                  </div>

                  <div v-else-if="field.type === 'radio'">
                    <label class="field-label d-block mb-2">
                      <img v-if="field.icon" :src="field.icon" class="img" />
                      {{ field.name }}
                      <span
                        class="text-danger"
                        v-if="Boolean(field.is_required)"
                        >*</span
                      >
                    </label>
                    <div
                      v-for="(option, i) in field?.options"
                      :key="i"
                      class="custom-radio-wrapper"
                    >
                      <input
                        type="radio"
                        class="custom-radio-input"
                        :id="`radio_${field.id}_${i}`"
                        :name="`radio_${field.id}`"
                        :value="option.id"
                        v-model="field.values.id"
                        :icon="field.icon"
                        :required="Boolean(field.is_required)"
                      />
                      <label
                        class="custom-radio-label"
                        :for="`radio_${field.id}_${i}`"
                      >
                        {{ option.name }}
                      </label>
                    </div>
                  </div>

                  <div v-else-if="field.type === 'select'">
                    <base-select-input
                      :placeholder="field.name"
                      :icon="field.icon"
                      :required="Boolean(field.is_required)"
                      :optionsList="
                        field.options?.map((option) => ({
                          name: option.name,
                          value: option?.name,
                          id: option.id,
                        }))
                      "
                      v-model="field.values"
                    />
                  </div>

                  <div v-else>
                    <small class="text-danger">
                      نوع غير مدعوم: {{ field.type }}
                    </small>
                  </div>
                </div>
              </div>
            </template>

            <div class="btn_wrapper col-12 text-end">
              <base-button
                class="mt-2"
                styleType="primary_btn"
                :btnText="$t('BUTTONS.save')"
                :isLoading="isWaitingRequest"
                :disabled="invalid || isWaitingRequest"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import moment from "moment";
import ChangableMapComponent from "../../../components/general/ChangableMapComponent.vue";
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";
import UploadMedia from "../../../components/formInputs/UploadMedia.vue";
export default {
  name: "EditAds",

  components: {
    BaseImageUploadInput,
    ChangableMapComponent,
    UploadsPhotos,
    UploadMedia,
  },

  data() {
    return {
      isWaitingRequest: false,
      currentDate: null,
      selectedDates: [],
      activePicker: "DATE",
      file: null,
      fileType: "",
      districts: [],
      cities: [],
      imgUrls: [],
      additional_fields: [],
      states: [],
      estateTypes: [],
      rent_days: [],
      data: {
        media: [],
        video: "",
        adNum: null,
        images: [],
        license_number: null,
        created_at: null,
        name: null,
        ad_type: null,
        estate_purpose: null,
        estate_type: null,
        is_featured: null,
        ban_type: null,
        price: null,
        state: null,
        city: null,
        district: null,
        lng: null,
        lat: null,
        rent_type: null,
        description: null,
        area: null,
        estate_front: null,
        street_width: null,
        additional_fields: [],
        last_updated_date: null,
        username: null,
        advertiser_type: null,
        advertiser_image: null,
        mobile: null,
        whatsapp: null,
      },
      initdist: null,
      initcity: null,
      initpurpose: false,
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },
  watch: {
    "data.estate_type"(newVal, oldVal) {
      if (newVal) {
        this.data.additional_fields = [];

        this.getadditionalFields(newVal.id);
      }
    },
    "data.additional_fields"(newVal, oldVal) {},
    "data.estate_purpose"(newval) {
      if (!this.initpurpose) {
        this.initpurpose = true;
        return;
      }
      this.data.estate_type = null;
      this.getEstateTypes(newval.value);
    },
    "data.state"(newVal) {
      if (!this.initcity) {
        this.initcity = true;
        return;
      }
      this.data.city = null;
      this.data.district = null;

      if (newVal) {
        this.getCities(newVal.id);
      }
    },
    "data.city"(newVal) {
      if (!this.initdist) {
        this.initdist = true;
        return;
      }
      this.data.district = null;
      this.initcity = true;

      if (newVal) {
        this.getDistricts(newVal.id);
      }
    },
  },

  computed: {
    currentLang() {
      return this.$i18n.locale;
    },
    adTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.sale"),
          value: "sale",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.rent"),
          value: "rent",
        },
      ];
    },

    rentTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.daily"),
          value: "daily",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.monthly"),
          value: "monthly",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.annual"),
          value: "annual",
        },
      ];
    },
    banTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.construction"),
          value: "construction",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.commercial"),
          value: "commercial",
        },
        {
          id: 3,
          name: this.$t("PLACEHOLDERS.other"),
          value: "other",
        },
      ];
    },
    estatePurposeTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.residential"),
          value: "residential",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.commercial"),
          value: "commercial",
        },
      ];
    },
    advertisersTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.owner"),
          value: "owner",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.broker"),
          value: "broker",
        },
      ];
    },
    facadeTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.northern"),
          value: "northern",
          nvalue: "northern",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.southern"),
          value: "southern",
          nvalue: "southern",
        },
        {
          id: 3,
          name: this.$t("PLACEHOLDERS.eastern"),
          value: "eastern",
          nvalue: "eastern",
        },
        {
          id: 4,
          name: this.$t("PLACEHOLDERS.western"),
          value: "western",
          nvalue: "western",
        },
        {
          id: 5,
          name: this.$t("PLACEHOLDERS.northeastern"),
          value: "northeastern",
          nvalue: "northeastern",
        },
        {
          id: 6,
          name: this.$t("PLACEHOLDERS.northwestern"),
          value: "northwestern",
          nvalue: "northwestern",
        },
        {
          id: 7,
          name: this.$t("PLACEHOLDERS.southeastern"),
          value: "southeastern",
          nvalue: "southeastern",
        },
        {
          id: 8,
          name: this.$t("PLACEHOLDERS.southwestern"),
          value: "southwestern",
          nvalue: "southwestern",
        },
      ];
    },
  },

  methods: {
    selectImages(selectedImage) {
      this.data.images = [...this.data.images, ...selectedImage];
    },

    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },
    toggleDate(date) {
      const parsedDate = new Date(date).toISOString().split("T")[0];
      const index = this.selectedDates.indexOf(parsedDate);
      if (index >= 0) {
        this.selectedDates.splice(index, 1);
      } else {
        this.selectedDates.push(parsedDate);
      }
    },
    handleFileSelected({ file, fileType }) {
      this.file = file;
      this.fileType = fileType;
    },
    handleFileRemoved() {
      this.file = null;
      this.fileType = "";
    },

    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
      return;
    },
    selectVideo(selectedVideo) {
      this.data.video = selectedVideo;
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.data.name) {
        REQUEST_DATA.append("name", this.data.name);
      }

      if (this.data.ad_type) {
        REQUEST_DATA.append("ad_type", this.data.ad_type.value);
      }

      if (this.data.rent_type) {
        REQUEST_DATA.append("rent_type", this.data.rent_type.value);
      }
      if (this.data.advertiser_type) {
        REQUEST_DATA.append("advertiser_type", this.data.advertiser_type.value);
      }
      if (this.data.license_number) {
        REQUEST_DATA.append(
          "advertiser_license_number",
          this.data.license_number
        );
      }

      if (this.data.ban_type && this.data.rent_type?.value !== "daily") {
        REQUEST_DATA.append("ban_type", this.data.ban_type.value);
      }
      if (this.rent_days && this.data.rent_type?.value == "daily") {
        this.rent_days.forEach((rent) => {
          REQUEST_DATA.append("rent_days[]", rent);
        });
      }
      if (this.data.estate_purpose) {
        REQUEST_DATA.append("estate_purpose", this.data.estate_purpose.value);
      }
      if (this.data.estate_type) {
        REQUEST_DATA.append("estate_type_id", this.data.estate_type.id);
      }
      if (this.data.price) {
        REQUEST_DATA.append("price", this.data.price);
      }
      if (this.data.description) {
        REQUEST_DATA.append("description", this.data.description);
      }
      if (this.data.area) {
        REQUEST_DATA.append("area", this.data.area);
      }
      if (this.data.street_width) {
        REQUEST_DATA.append("street_width", this.data.street_width);
      }
      if (this.data.estate_front && this.data.rent_type?.value !== "daily") {
        REQUEST_DATA.append("estate_front", this.data.estate_front.value);
      }

      if (this.data.state) {
        REQUEST_DATA.append("state_id", this.data.state.id);
      }

      if (this.data.city) {
        REQUEST_DATA.append("city_id", this.data.city.id);
      }
      if (this.data.district) {
        REQUEST_DATA.append("district_id", this.data.district.id);
      }
      if (this.data.lat) {
        REQUEST_DATA.append("lat", this.data.lat);
      }

      if (this.data.lng) {
        REQUEST_DATA.append("lng", this.data.lng);
      }
      if (this.data.video.file) {
        REQUEST_DATA.append("video", this.data.video.file);
      }

      if (this.data.additional_fields) {
        this.data.additional_fields.forEach((field, index) => {
          REQUEST_DATA.append(`additional_fields[${index}][id]`, field.id);

          if (field.type == "checkbox") {
            field.values.forEach((val, i) => {
              REQUEST_DATA.append(
                `additional_fields[${index}][value][${i}]`,
                val
              );
            });
          } else {
            REQUEST_DATA.append(
              `additional_fields[${index}][value]`,
              field.values?.id ?? field.values
            );
          }
        });
      }

      if (this.$refs.ad_images?.getFiles().length) {
        this.$refs.ad_images?.getFiles().forEach((file, index) => {
          if (file.file instanceof File) {
            REQUEST_DATA.append(`images[]`, file.file);
          }
        });
      }

      REQUEST_DATA.append("_method", "PUT");

      try {
        await this.$axios({
          method: "POST",
          url: `ads/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/advertisements/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    async getAdsData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `ads/${this.$route.params.id}`,
        });

        this?.$refs?.ad_images.setFiles(
          res.data.data.Ad.media.map((img) => {
            return { id: img.id, url: img.image };
          })
        );

        this.data.video = {
          path: res.data.data.Ad.video,
          file: null,
        };
        this.data.description = res.data.data.Ad.description;

        this.data.adNum = res.data.data.Ad.id;
        this.data.license_number = res.data.data.Ad.advertiser_license_number;
        this.data.name = res.data.data.Ad.name;
        this.data.created_at = res.data.data.Ad.created_at;
        this.data.ad_type = this.adTypes.find((type) => {
          return type.value === res.data.data.Ad.ad_type;
        });
        this.data.estate_purpose = this.estatePurposeTypes.find((type) => {
          return type.value === res.data.data.Ad.estate_purpose;
        });
        this.data.ban_type = this.banTypes.find((type) => {
          return type.value === res.data.data.Ad.ban_type;
        });
        this.getEstateTypes(this.data.estate_purpose.value);
        this.data.estate_type = res.data.data.Ad.estate_type;

        this.data.price = res.data.data.Ad.price;
        this.data.state = res.data.data.Ad.state;
        this.data.city = res.data.data.Ad.city;
        this.data.district = res.data?.data?.Ad?.district;

        if (this.data.state?.id) {
          await this.getCities(this.data.state.id);
        }

        if (this.data.city?.id) {
          await this.getDistricts(this.data.city.id);
        }

        await this.getadditionalFields(this.data.estate_type.id);
        this.data.is_featured = res.data.data.Ad.is_featured;

        this.rent_days = res.data?.data?.Ad?.rent_days?.map((day) => day.date);
        this.data.lng = res.data?.data.Ad.lng;
        this.data.lat = res.data?.data.Ad.lat;
        if (res.data?.data?.Ad?.ad_type === "rent") {
          this.data.rent_type = this.rentTypes.find((type) => {
            {
              return type.value === res.data.data.Ad.rent_type;
            }
          });
        }
        this.data.area = res.data.data.Ad?.area;
        this.data.estate_front = this.facadeTypes?.find((type) => {
          return type.value == res.data.data.Ad?.estate_front;
        });
        this.data.street_width = res.data.data.Ad?.street_width;
        this.data.additional_fields = res.data.data.Ad?.additional_fields.map(
          (field) => {
            if (field.type === "checkbox") {
              return {
                ...field,
                values: field.values.map((val) => val.id),
              };
            } else {
              return field;
            }
          }
        );
        this.data.last_updated_date = res.data.data.Ad?.last_updated_date;
        this.data.username = res.data.data.Ad?.advertiser?.user?.name;
        this.data.advertiser_type = this.advertisersTypes.find((type) => {
          return res.data.data.Ad?.advertiser_type == type.value;
        });
        this.data.advertiser_image = res.data.data.Ad?.advertiser.user?.image;
        this.data.mobile = res.data.data.Ad?.advertiser.user?.mobile;
        this.data.whatsapp = res.data.data.Ad?.advertiser.user?.whatsapp;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },

    async getEstateTypes(type) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `estate-types?page=0&limit=0&is_active=1&type=${type}&ignorePermissionCheck=1`,
        });
        this.estateTypes = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getStates() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `states?page=0&limit=0&is_active=1&ignorePermissionCheck=1`,
        });
        this.states = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getDistricts(id) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `districts?page=0&limit=0&is_active=1&city=${id}&ignorePermissionCheck=1`,
        });
        this.districts = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getCities(id) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `cities?page=0&limit=0&is_active=1&state=${id}&ignorePermissionCheck=1`,
        });
        this.cities = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getadditionalFields(id) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `additional-fields?page=0&limit=0&is_active=1&estateType=${id}&ignorePermissionCheck=1`,
        });
        this.additional_fields = res.data.data.map((field) => ({
          values: [],
          ...field,
        }));
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    this.getadditionalFields();
    this.getAdsData();

    this.getStates();
  },
};
</script>

<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 20px;
}

.custom-radio-wrapper {
  position: relative;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
}

.custom-radio-input {
  position: absolute;
  opacity: 0;
}

.custom-radio-label {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  border: px solid #d0d0d0;
  border-radius: 10px;
  transition: 0.25s;
  font-weight: 500;
  cursor: pointer;
  min-height: 44px;
  user-select: none;
  background-color: #fff;
}

.custom-radio-circle {
  width: 18px;
  height: 18px;
  border: 2px solid #007bff;
  border-radius: 50%;
  margin-right: 10px;
  display: inline-block;
  position: relative;
  transition: 0.25s ease-in-out;
}
.custom-radio-input:checked:disabled
  + .custom-radio-label
  .custom-radio-circle::after {
  content: "";
  width: 10px;
  height: 10px;
  background-color: green !important;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 3px;
  opacity: 0.5; /* يخليها باهتة شوية */
}
.custom-radio-input:checked + .custom-radio-label {
  border-color: #007bff;
  background-color: #f0f8ff;
}
.custom-radio-input:checked:disabled + .custom-radio-label {
  border-color: #007bff;
  background-color: #f5f5f5;
  color: #007bff;
}
.custom-radio-label:hover {
  background-color: #f9f9f9;
  border-color: #007bff;
}

.custom-radio-input:disabled + .custom-radio-label {
  border-color: #ccc;
  color: var(--theme_text_clr);
  cursor: not-allowed;
}
.custom-radio-input:disabled + .custom-radio-label .custom-radio-circle {
  border-color: #ccc;
}
.custom-checkbox-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-weight: 500;
  position: relative;
}

.custom-checkbox-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.custom-checkbox-box {
  width: 20px;
  height: 20px;
  border: 2px solid #28a745;
  background-color: #fff;
  border-radius: 4px;
  margin-right: 10px;
  transition: all 0.2s ease-in-out;
  position: relative;
}

.custom-checkbox-input:checked + .custom-checkbox-box::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 6px;
  height: 12px;
  border: solid #28a745;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.custom-checkbox-input:checked + .custom-checkbox-box {
  background-color: #e9f9ee;
  border-color: #28a745;
}

.custom-checkbox-label {
  font-size: 16px;
  color: var(--main_theme_clr);
}

.custom-checkbox-input:disabled + .custom-checkbox-box {
  background-color: #f1f1f1;
  border-color: #ccc;
}
.custom-checkbox-input:disabled ~ .custom-checkbox-label {
  color: var(--theme_text_clr);
  cursor: not-allowed;
}

.custom-form-wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  border-radius: 12px;
}

.custom-form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-weight: 600;
  margin-bottom: 4px;
  color: var(--theme_text_clr);
  font-size: 14px;
}

.custom-checkbox-wrapper,
.custom-radio-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.custom-checkbox-box,
.custom-radio-input {
  accent-color: #1976d2;
}

.custom-checkbox-label,
.custom-radio-label {
  font-size: 14px;
  color: var(--theme_text_clr);
}

.custom-checkbox-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-weight: 500;
  margin-bottom: 0.75rem;
  position: relative;
}

.custom-checkbox-input {
  position: absolute;
  opacity: 0;
}

.custom-checkbox-box {
  width: 20px;
  height: 20px;
  border: 2px solid #28a745;
  background-color: #fff;
  border-radius: 4px;
  margin-right: 10px;
  transition: 0.2s ease-in-out;
  position: relative;
}

.custom-checkbox-input:checked ~ .custom-checkbox-box::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 6px;
  height: 12px;
  border: solid #28a745;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.custom-checkbox-input:checked ~ .custom-checkbox-box {
  background-color: #eafaf0;
  border-color: #28a745;
}

.custom-checkbox-label {
  font-size: 16px;
  color: var(--theme_text_clr);
}

.img {
  width: 25px;
  border-radius: 50%;
  height: 25px;
  display: inline-block;
  object-fit: cover;
}
</style>
